import { useEffect, useMemo } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { routes } from '~/routes.tsx';
import { setTokenGetter } from '~/apollo';

const App = () => {
  const { getAccessTokenSilently } = useAuth0();
  const router = useMemo(() => createBrowserRouter([...routes]), []);

  useEffect(() => {
    setTokenGetter(getAccessTokenSilently);
  }, [getAccessTokenSilently]);

  return <RouterProvider router={router} />;
};

export default App;
